var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-create',_vm._g(_vm._b({attrs:{"name":"settings-payment-subscription-create","title":`${_vm.subscription.title} abonnieren`}},'base-create',_vm.$attrs,false),_vm.$listeners),[_c('SettingsPaymentSubscriptionForm',{attrs:{"type":"create","subscription":_vm.subscription}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }